export enum Language {
    English = 1,
    Dutch = 2,
    Norwegian = 3,
}
